module.exports = __webpack_public_path__ + "static/media/gearbox.7eeccb04.svg";